import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { usePageMeta } from '@/hooks/usePageMeta';
import { newsList } from '@/mocks/news';
import { heroSlides } from '@/mocks/carousel';
import { topicList } from '@/mocks/topics';
import HeroCarousel from './components/HeroCarousel';
import QuickEntries from './components/QuickEntries';
import LatestNews from './components/LatestNews';
import HotRanking from './components/HotRanking';
import SiteIntro from './components/SiteIntro';
import { formatViews } from '@/utils/format';

export default function Home() {
  usePageMeta({
    title: '靠逼 - 综合娱乐资讯与最新动态',
    description:
      '靠逼网站汇聚最新娱乐新闻、影视推荐及热门话题，提供丰富的内容资讯，满足用户多样娱乐需求。',
    keywords: '靠逼,娱乐资讯,影视新闻,热门话题,娱乐动态',
  });

  const latest = useMemo(
    () =>
      [...newsList]
        .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1))
        .slice(0, 10),
    [],
  );

  const hot = useMemo(() => [...newsList].sort((a, b) => b.views - a.views).slice(0, 5), []);
  const hotTopics = useMemo(() => [...topicList].sort((a, b) => b.heat - a.heat).slice(0, 5), []);

  return (
    <div className="w-full">
      <HeroCarousel slides={heroSlides} />
      <QuickEntries />

      <div className="mx-auto max-w-7xl px-4 pb-4 md:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <LatestNews items={latest} />
          </div>
          <aside className="flex flex-col gap-6">
            <HotRanking items={hot} />

            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-2 border-b border-background-200 pb-3">
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className="ri-chat-3-line text-lg" />
                </span>
                <h2 className="font-heading text-lg font-bold text-foreground-950">热议话题</h2>
                <Link
                  to="/hot-topics"
                  className="ml-auto text-xs text-foreground-500 transition-colors hover:text-primary-600"
                >
                  更多
                </Link>
              </div>
              <div className="mt-3 flex flex-col gap-3">
                {hotTopics.map((t, i) => (
                  <Link
                    key={t.id}
                    to="/hot-topics"
                    className="group flex items-start gap-3 rounded-md border border-background-100 p-3 transition-colors hover:border-primary-300 hover:bg-primary-50/40"
                  >
                    <span className="font-heading text-lg font-black text-background-300 transition-colors group-hover:text-primary-400">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="line-clamp-1 text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-600">
                        {t.title}
                      </span>
                      <span className="mt-1 flex items-center gap-2 text-[11px] text-foreground-400">
                        <span className="flex items-center gap-1">
                          <i className="ri-fire-line" />
                          {formatViews(t.heat)} 热度
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-user-voice-line" />
                          {formatViews(t.participants)} 人参与
                        </span>
                      </span>
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>

      <SiteIntro />
    </div>
  );
}